



















































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import dxDataGrid from 'devextreme/ui/data_grid';
import { DxButton } from 'devextreme-vue/button';
import {
  DxColumn,
  DxDataGrid,
  DxEditing,  
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPaging,
  DxPopup,
  DxRequiredRule,
  DxScrolling,
  DxStateStoring
} from 'devextreme-vue/data-grid';
import { DxButtonItem, DxGroupItem, DxItem } from 'devextreme-vue/form';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxRadioGroup } from 'devextreme-vue/radio-group';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTextBox } from 'devextreme-vue/text-box';
import TextPopup from '@/components/text-popup.vue';
import { SelectOption } from '@/models/SelectOption';
import { FeeBudgetRuleDto } from '@/models/fee-budgets/FeeBudgetRuleDto';
import { FeeSheetTypeEnum, FeeSheetTypeNameEnum } from '@/models/Fees/FeeSheetTypeEnum';
import { AgentService } from '@/service/AgentService';
import { ClientService } from '@/service/ClientService';
import { CountryService } from '@/service/CountryService';
import { FeeBudgetRuleService } from '@/service/FeeBudgetRuleService';
import { PhaseTypeService } from '@/service/PhaseTypeService';
import String from '@/utilities/String';
import _ from 'lodash';

@Component({
  components: {
    DxButton,
    DxButtonItem,
    DxColumn,
    DxDataGrid,
    DxEditing,    
    DxForm,
    DxFormItem,
    DxGroupItem,
    DxHeaderFilter,
    DxItem,
    DxLookup,
    DxNumberBox,
    DxPaging,
    DxPopup,
    DxRadioGroup,
    DxRequiredRule,
    DxScrolling,
    DxSelectBox,
    DxStateStoring,
    DxTextArea,
    DxTextBox,
    TextPopup
  }
})
export default class FeeBudgetList extends Vue {
  private readonly feeBudgetRuleService: FeeBudgetRuleService = new FeeBudgetRuleService();
  private readonly agentService: AgentService = new AgentService();
  private readonly clientService: ClientService = new ClientService();
  private readonly countryService: CountryService = new CountryService();
  private readonly phaseTypeService: PhaseTypeService = new PhaseTypeService();

  private dataGrid: dxDataGrid | undefined;
  private selectedClient: Guid = '';
  private clientMatters: SelectOption[] = [];
  private clientAgents: SelectOption[] = this.getDefaultClientAgents();
  private insertingMatter: boolean = false;

  private isReadOnly: boolean = false;

  showNotes: boolean = false;
  notesToShow: string = '';
  clients: SelectOption[] = [];
  agents: SelectOption[] = [];
  countries: SelectOption[] = [];
  phaseTypes: SelectOption[] = [];
  ruleTypes: SelectOption[] = [
    { text: FeeSheetTypeNameEnum.Cap, value: FeeSheetTypeEnum.Cap },
    { text: FeeSheetTypeNameEnum.Target, value: FeeSheetTypeEnum.Target }
  ];

  @Watch('selectedClient')
  async onSelectedClientChanged() {    
    this.clientMatters = [];
    this.clientAgents = this.getDefaultClientAgents();
    this.insertingMatter = false;

    if (String.isNullOrEmpty(this.selectedClient)) {
      return;
    }

    this.clientMattersDataSource.pageIndex(0);
    await this.clientMattersDataSource.reload();

    this.clientAgents = await this.agentService.getAllSelectOptions(this.selectedClient);
    this.clientAgentsDataSource.pageIndex(0);
    await this.clientAgentsDataSource.reload();
  }

  get feeBudgetRulesDataSource() {
    return new CustomStore({
      key: 'FeeBudgetRuleId',
      load: options => this.feeBudgetRuleService.list(options).catch(this.handleResponseError),
      insert: values => this.feeBudgetRuleService.create(values).catch(this.handleResponseError),
      update: (key, values) => this.feeBudgetRuleService.update(key, values).catch(this.handleResponseError),
      remove: key => this.feeBudgetRuleService.delete(key).catch(this.handleResponseError)
    });
  }

  get clientMattersDataSource() {
    return new DataSource({
      loadMode: 'raw',
      load: () => {
        if (this.insertingMatter) {
          this.insertingMatter = false;
          return this.clientMatters;
        }

        if (String.isNullOrEmpty(this.selectedClient)) {
          return [];
        }

        return this.clientService.getMatterSelectOptions(this.selectedClient)
          .then(result => {
            this.clientMatters = result;
            return result;
          });
      },
      insert: values => {
        if (this.clientMatters.findIndex(m => m.value === values.value) === -1) {
          this.clientMatters.unshift(values);
        }

        return Promise.resolve(values);
      },
      paginate: true,
      pageSize: 100
    });
  }

  get clientAgentsDataSource() {    
    return new DataSource({
      store: this.clientAgents,
      paginate: true,
      pageSize: 100
    });
  }

  private handleResponseError(result: any) {
    let message = 'An unknown error occurred.';
    if (result && result.Message) {
      message = result.Message;

      let index = message.indexOf(' (Error');
      if (index > -1) {
        message = message.substring(0, index);
      }
    }

    throw Error(message);
  }

  async created() {
    document.addEventListener('keyup', this.onKeyup, true);
    document.addEventListener('keydown', this.onKeydown, true);
    await this.loadData();
  }

  private async loadData() {
    this.clients = await this.clientService.getAllSelectOptions();
    this.agents = await this.agentService.getAllSelectOptions();
    this.countries = await this.countryService.getAllSelectOptions();
    this.phaseTypes = await this.phaseTypeService.getAllSelectOptions();
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup, true);
    document.removeEventListener('keydown', this.onKeydown, true);
  }

  private onClientSelectionChanged(value: Guid, cellInfo: any) {    
    this.selectedClient = value;
    cellInfo.setValue(value);
  }  

  onCreatingCustomMatterName(e: any) {
    e.customItem = { text: e.text, value: e.text };
    this.insertingMatter = true;
    this.clientMattersDataSource.store().insert(e.customItem);
    this.clientMattersDataSource.reload();
  }

  openNotes(rule: FeeBudgetRuleDto) {
    this.notesToShow = rule.Notes;
    this.showNotes = true;
  }

  closeNotes() {
    this.showNotes = false;
    this.notesToShow = '';
  }

  onDataGridInitialized(e: any) {
    this.dataGrid = e.component;
  }

  initNewRow(e: any) {        
    this.isReadOnly = false;    
    e.data.Amount = 0;
    e.data.CapOrTarget = FeeSheetTypeEnum.Cap;
    e.data.AgentId = '';
  }

  onEditingStart(e: any) {        
    this.isReadOnly = true;    
    if (e.data.AgentId == null) {
      e.data.AgentId = '';
    }
  }

  onRowUpdating(e: any) {        
    e.newData = _.merge({}, e.oldData, e.newData);
  }

  onPopupShowing(e: any) {    
    let toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  } 

  onValueChanged(value: any, cellInfo: any) {
    cellInfo.setValue(value);
  }

  private getDefaultClientAgents(): SelectOption[] {
    return [{ text: 'ALL', value: '' }];
  }

  customizeEmptyText(cellInfo: any) {
    return String.isNullOrEmpty(cellInfo.valueText) ? 'ALL' : cellInfo.valueText;
  }

  async save() {    
    this.focusDataGrid();
    if (this.hasEditData()) {
      await this.saveEditData();
    }
  }

  private hasEditData() {
    return this.dataGrid != null && this.dataGrid.hasEditData();
  }

  private async saveEditData() {
    if (this.dataGrid != null) {
      await this.dataGrid.saveEditData();
    }
  }

  private onKeydown(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  private onKeyup(e: KeyboardEvent) {
    if (this.isSaveShortcut(e)) {
      e.preventDefault();
      e.stopPropagation();
      this.save();
    }
  }

  private isSaveShortcut(e: KeyboardEvent) {
    return e.key === 'Enter' && (e.ctrlKey || e.shiftKey);
  }

  private focusDataGrid() {
    if (this.dataGrid != null) {
      this.dataGrid.focus();
    }
  }
}
